/* ============================================================
   MOULÉE PDP — Interactive JavaScript
   Flock Calculator, Variant Selector, Sticky ATC,
   FAQ Accordion, Guaranteed Analysis
   ============================================================ */

(function() {
  'use strict';

  /* ----------------------------------------------------------
     VARIANT SELECTOR
     ---------------------------------------------------------- */
  function initVariantSelector() {
    var pills = document.querySelectorAll('[data-mpdp-variant]');
    var priceEl = document.querySelector('[data-mpdp-price]');
    var priceKgEl = document.querySelector('[data-mpdp-price-kg]');
    var variantInput = document.querySelector('[data-mpdp-variant-id]');
    var stickyPrice = document.querySelector('.mpdp-sticky-atc__price');
    var moneyFmt = document.querySelector('[data-mpdp-money-format]');
    var format = moneyFmt ? moneyFmt.dataset.mpdpMoneyFormat : '${{amount}}';

    if (!pills.length) return;

    pills.forEach(function(pill) {
      pill.addEventListener('click', function() {
        pills.forEach(function(p) { p.classList.remove('mpdp-hero__variant-pill--active'); });
        pill.classList.add('mpdp-hero__variant-pill--active');

        var vid = pill.dataset.mpdpVariant;
        var price = pill.dataset.mpdpVariantPrice;
        var weight = pill.dataset.mpdpVariantWeight;
        var isAvail = pill.dataset.mpdpVariantAvailable === 'true';

        if (variantInput) variantInput.value = vid;

        var formatted = formatMoney(price, format);
        if (priceEl) priceEl.textContent = formatted;
        if (stickyPrice) stickyPrice.textContent = formatted;

        if (priceKgEl && weight && parseFloat(weight) > 0) {
          var perKg = (parseFloat(price) / 100) / parseFloat(weight);
          priceKgEl.textContent = perKg.toFixed(2) + ' $/kg';
        }

        var atcBtn = document.querySelector('[data-mpdp-atc]');
        var stickyBtn = document.querySelector('[data-mpdp-sticky-atc-btn]');
        if (atcBtn) {
          atcBtn.disabled = !isAvail;
          atcBtn.textContent = isAvail ? 'Ajouter au panier' : 'Rupture de stock';
        }
        if (stickyBtn) {
          stickyBtn.disabled = !isAvail;
          stickyBtn.textContent = isAvail ? 'Ajouter' : 'Rupture de stock';
        }

        var url = new URL(window.location);
        url.searchParams.set('variant', vid);
        history.replaceState(null, '', url.toString());

        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: { variant: { id: vid, available: isAvail } }
        }));
      });
    });
  }

  /* ----------------------------------------------------------
     IMAGE GALLERY
     ---------------------------------------------------------- */
  function initImageGallery() {
    var thumbs = document.querySelectorAll('[data-mpdp-thumb-index]');
    var medias = document.querySelectorAll('[data-mpdp-media-index]');
    if (!thumbs.length || !medias.length) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var idx = thumb.dataset.mpdpThumbIndex;
        thumbs.forEach(function(t) { t.classList.remove('mpdp-hero__thumb--active'); });
        thumb.classList.add('mpdp-hero__thumb--active');
        medias.forEach(function(m) {
          m.hidden = m.dataset.mpdpMediaIndex !== idx;
          m.classList.remove('mpdp-hero__media--zoomed');
        });
      });
    });
  }

  /* ----------------------------------------------------------
     QUANTITY SELECTOR
     ---------------------------------------------------------- */
  function initQuantitySelector() {
    var minus = document.querySelector('[data-mpdp-qty-minus]');
    var plus = document.querySelector('[data-mpdp-qty-plus]');
    var input = document.querySelector('[data-mpdp-qty-input]');
    var count = document.querySelector('[data-mpdp-qty-count]');
    if (!minus || !plus || !input) return;

    function update(val) {
      val = Math.max(1, Math.min(99, val));
      input.value = val;
      if (count) count.textContent = val;
      minus.disabled = (val <= 1);
    }

    minus.addEventListener('click', function() { update(parseInt(input.value) - 1); });
    plus.addEventListener('click', function() { update(parseInt(input.value) + 1); });
    update(1);
  }

  /* ----------------------------------------------------------
     FLOCK CALCULATOR
     ---------------------------------------------------------- */
  function initFlockCalculator() {
    var calc = document.querySelector('[data-mpdp-flock-calc]');
    if (!calc) return;

    var hensInput = calc.querySelector('[data-mpdp-calc-hens]');
    var rateInput = calc.querySelector('[data-mpdp-calc-rate]');
    var bagWeight = parseFloat(calc.dataset.mpdpBagWeight) || 25;

    var resultBags = calc.querySelector('[data-mpdp-calc-bags]');
    var resultCost = calc.querySelector('[data-mpdp-calc-cost]');
    var resultPerHen = calc.querySelector('[data-mpdp-calc-per-hen]');
    var calcAtcBtn = calc.querySelector('[data-mpdp-calc-atc]');
    var calcQtyDisplay = calc.querySelector('[data-mpdp-calc-qty-display]');

    var debounceTimer;

    function getActivePrice() {
      var activePill = document.querySelector('.mpdp-hero__variant-pill--active');
      if (activePill) return parseFloat(activePill.dataset.mpdpVariantPrice) || 0;
      return 0;
    }

    function calculate() {
      var hens = parseInt(hensInput.value) || 0;
      var dailyG = parseInt(rateInput ? rateInput.value : 110) || 110;

      if (hens <= 0) {
        if (resultBags) resultBags.textContent = '—';
        if (resultCost) resultCost.textContent = '—';
        if (resultPerHen) resultPerHen.textContent = '—';
        if (calcAtcBtn) calcAtcBtn.disabled = true;
        return;
      }

      var kgPerMonth = (hens * dailyG * 30) / 1000;
      var bagsPerMonth = Math.ceil(kgPerMonth / bagWeight);
      var priceCents = getActivePrice();
      var costPerMonth = bagsPerMonth * (priceCents / 100);
      var costPerHenPerDay = priceCents > 0 ? (costPerMonth / hens / 30) : 0;

      if (resultBags) resultBags.textContent = bagsPerMonth;
      if (resultCost) resultCost.textContent = costPerMonth.toFixed(2) + ' $';
      if (resultPerHen) resultPerHen.textContent = costPerHenPerDay.toFixed(2) + ' $';
      if (calcQtyDisplay) calcQtyDisplay.textContent = bagsPerMonth + ' sac' + (bagsPerMonth > 1 ? 's' : '') + ' de ' + bagWeight + ' kg';
      if (calcAtcBtn) {
        calcAtcBtn.disabled = false;
        calcAtcBtn.dataset.mpdpCalcQty = bagsPerMonth;
      }
    }

    function debouncedCalc() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(calculate, 200);
    }

    if (hensInput) hensInput.addEventListener('input', debouncedCalc);
    if (rateInput) rateInput.addEventListener('input', debouncedCalc);

    // +/- buttons for hen count
    var hensMinus = calc.querySelector('[data-mpdp-calc-hens-minus]');
    var hensPlus = calc.querySelector('[data-mpdp-calc-hens-plus]');
    if (hensMinus) {
      hensMinus.addEventListener('click', function() {
        hensInput.value = Math.max(1, (parseInt(hensInput.value) || 0) - 1);
        debouncedCalc();
      });
    }
    if (hensPlus) {
      hensPlus.addEventListener('click', function() {
        hensInput.value = Math.min(200, (parseInt(hensInput.value) || 0) + 1);
        debouncedCalc();
      });
    }

    // ATC from calculator
    if (calcAtcBtn) {
      calcAtcBtn.addEventListener('click', function() {
        var vid = document.querySelector('[data-mpdp-variant-id]');
        var qty = parseInt(calcAtcBtn.dataset.mpdpCalcQty) || 1;
        if (vid) addToCart(vid.value, qty, calcAtcBtn);
      });
    }

    // Recalculate when variant changes
    document.addEventListener('variant:change', function() {
      calculate();
    });

    calculate();
  }

  /* ----------------------------------------------------------
     GUARANTEED ANALYSIS — mobile expand/collapse
     ---------------------------------------------------------- */
  function initAnalysisTable() {
    var expandBtn = document.querySelector('[data-mpdp-analysis-expand]');
    var hiddenRows = document.querySelectorAll('[data-mpdp-analysis-hidden]');
    if (!expandBtn || !hiddenRows.length) return;

    expandBtn.addEventListener('click', function() {
      var isExpanded = expandBtn.dataset.expanded === 'true';
      hiddenRows.forEach(function(row) {
        row.style.display = isExpanded ? 'none' : '';
      });
      expandBtn.dataset.expanded = isExpanded ? 'false' : 'true';
      expandBtn.textContent = isExpanded ? 'Voir l\u2019analyse compl\u00e8te \u25BC' : 'R\u00e9duire \u25B2';
    });
  }

  /* ----------------------------------------------------------
     STICKY ATC
     ---------------------------------------------------------- */
  function initStickyATC() {
    var sticky = document.querySelector('.mpdp-sticky-atc');
    var heroSection = document.querySelector('.mpdp-hero');
    if (!sticky || !heroSection) return;

    document.body.appendChild(sticky);

    var headerEl = document.querySelector('.shopify-section-header');
    function updateStickyOffset() {
      if (window.innerWidth > 768 && headerEl) {
        var headerH = headerEl.getBoundingClientRect().height;
        sticky.style.setProperty('--mpdp-sticky-offset', headerH + 'px');
      } else {
        sticky.style.setProperty('--mpdp-sticky-offset', '0px');
      }
    }
    updateStickyOffset();

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          sticky.classList.remove('is-visible');
          sticky.setAttribute('aria-hidden', 'true');
        } else {
          if (entry.boundingClientRect.bottom < 0) {
            sticky.classList.add('is-visible');
            sticky.setAttribute('aria-hidden', 'false');
            updateStickyOffset();
          }
        }
      });
    }, { threshold: 0 });

    observer.observe(heroSection);

    var stickyBtn = sticky.querySelector('[data-mpdp-sticky-atc-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        var vid = document.querySelector('[data-mpdp-variant-id]');
        var qty = document.querySelector('[data-mpdp-qty-input]');
        var quantity = qty ? parseInt(qty.value) || 1 : 1;
        if (vid) addToCart(vid.value, quantity, stickyBtn);
      });
    }
  }

  /* ----------------------------------------------------------
     CART API — matches fg-fastbuy + product-form.js pattern
     ---------------------------------------------------------- */
  function addToCart(variantId, quantity, triggerBtn) {
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);

    // Cart drawer integration (matches fg-fastbuy + product-form.js)
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      formData.append('sections', cartDrawer.getSectionsToRender().map(function(s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
      if (typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(document.activeElement);
      }
    }

    if (triggerBtn) {
      triggerBtn.disabled = true;
      triggerBtn.dataset.origText = triggerBtn.textContent;
      triggerBtn.textContent = '\u2026';
    }

    var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    var controller = new AbortController();
    var timer = setTimeout(function() { controller.abort(); }, 8000);

    fetch(cartAddUrl, {
      method: 'POST',
      body: formData,
      signal: controller.signal,
      headers: {
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(function(res) {
      clearTimeout(timer);
      if (!res.ok) throw new Error('HTTP ' + res.status);
      var ct = res.headers.get('content-type') || '';
      if (ct.indexOf('text/html') > -1) {
        // Got HTML instead of JSON — open cart drawer or redirect
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        return null;
      }
      return res.json();
    })
    .then(function(data) {
      if (!data) return;
      if (triggerBtn) {
        triggerBtn.textContent = 'Ajout\u00e9 \u2713';
        setTimeout(function() {
          triggerBtn.textContent = triggerBtn.dataset.origText;
          triggerBtn.disabled = false;
        }, 2000);
      }
      // Cart drawer update
      if (cartDrawer) {
        if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
        if (typeof cartDrawer.renderContents === 'function') cartDrawer.renderContents(data);
      }
      // Publish events for theme integration.
      // Use source:'cart-items' so the CartItems subscriber (which on a PDP is the
      // <cart-drawer-items> element) skips its onCartUpdate refetch — that handler
      // pulls main-cart-items HTML and overwrites the freshly-rendered drawer body,
      // which is what produced the "drawer opens empty after calculator ATC" bug.
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', productVariantId: variantId });
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: { id: variantId, quantity: quantity } }
      }));
    })
    .catch(function(err) {
      clearTimeout(timer);
      console.error('[mpdp] ATC error:', err);
      // Fallback: native form POST
      var form = document.querySelector('[data-mpdp-form]');
      if (form) {
        var vidInput = form.querySelector('[data-mpdp-variant-id]');
        var qtyInput = form.querySelector('[data-mpdp-qty-input]');
        if (vidInput) vidInput.value = variantId;
        if (qtyInput) qtyInput.value = quantity;
        HTMLFormElement.prototype.submit.call(form);
      } else if (triggerBtn) {
        triggerBtn.textContent = 'Erreur';
        setTimeout(function() {
          triggerBtn.textContent = triggerBtn.dataset.origText;
          triggerBtn.disabled = false;
        }, 2000);
      }
    });
  }

  /* ----------------------------------------------------------
     FAQ ACCORDION
     ---------------------------------------------------------- */
  function initFaqAccordion() {
    var items = document.querySelectorAll('.mpdp-faq__item');
    if (!items.length) return;

    items.forEach(function(item) {
      item.addEventListener('toggle', function() {
        if (item.open) {
          items.forEach(function(other) {
            if (other !== item && other.open) other.open = false;
          });
        }
      });
    });

    // FR/EN toggle
    var langBtns = document.querySelectorAll('[data-mpdp-faq-lang]');
    langBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var lang = btn.dataset.mpdpFaqLang;
        langBtns.forEach(function(b) { b.classList.remove('mpdp-faq__lang-btn--active'); });
        btn.classList.add('mpdp-faq__lang-btn--active');
        document.querySelectorAll('[data-mpdp-faq-fr]').forEach(function(el) {
          var hide = lang !== 'fr';
          el.classList.toggle('mpdp-faq__item--lang-hidden', hide);
          el.setAttribute('aria-hidden', hide ? 'true' : 'false');
        });
        document.querySelectorAll('[data-mpdp-faq-en]').forEach(function(el) {
          var hide = lang !== 'en';
          el.classList.toggle('mpdp-faq__item--lang-hidden', hide);
          el.setAttribute('aria-hidden', hide ? 'true' : 'false');
        });
      });
    });
  }

  /* ----------------------------------------------------------
     SCROLL REVEAL
     ---------------------------------------------------------- */
  function initScrollReveal() {
    var els = document.querySelectorAll('.mpdp-reveal, .mpdp-reveal-stagger > *');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function(el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function(el) { observer.observe(el); });
  }

  /* ----------------------------------------------------------
     HERO FORM INTERCEPT
     ---------------------------------------------------------- */
  function initHeroFormIntercept() {
    // Direct click listener on ATC button (matches fg-fastbuy pattern)
    var atcBtn = document.querySelector('[data-mpdp-atc]');
    console.log('[mpdp] initHeroFormIntercept: atcBtn=', !!atcBtn);
    if (atcBtn) {
      atcBtn.addEventListener('click', function(e) {
        console.log('[mpdp] ATC click fired');
        e.preventDefault();
        e.stopPropagation();
        var vid = document.querySelector('[data-mpdp-variant-id]');
        var qtyCount = document.querySelector('[data-mpdp-qty-count]');
        var qty = qtyCount ? parseInt(qtyCount.textContent.trim()) || 1 : 1;
        if (vid && vid.value) addToCart(vid.value, qty, atcBtn);
      });
    }

    // Also prevent native form submit as safety net
    var form = document.querySelector('[data-mpdp-form]');
    if (form) {
      form.addEventListener('submit', function(e) { e.preventDefault(); });
    }
  }

  /* ----------------------------------------------------------
     JUMP LINKS
     ---------------------------------------------------------- */
  function initJumpLinks() {
    var links = document.querySelectorAll('.mpdp-hero__jump-link, [data-mpdp-scroll]');
    links.forEach(function(link) {
      link.addEventListener('click', function(e) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        var y = target.getBoundingClientRect().top + window.pageYOffset - 140;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }

  /* ----------------------------------------------------------
     MONEY FORMAT HELPER
     ---------------------------------------------------------- */
  function formatMoney(cents, format) {
    var amount = (parseFloat(cents) / 100).toFixed(2);
    var amountNoDec = Math.floor(parseFloat(cents) / 100);
    var amountComma = amount.replace('.', ',');
    return format
      .replace('{{amount_with_comma_separator}}', amountComma)
      .replace('{{amount_no_decimals}}', amountNoDec)
      .replace('{{amount}}', amount);
  }

  /* ----------------------------------------------------------
     IMAGE ZOOM
     ---------------------------------------------------------- */
  function initImageZoom() {
    var gallery = document.querySelector('[data-mpdp-zoom]');
    if (!gallery) return;

    // Desktop: track mouse for transform-origin
    gallery.addEventListener('mousemove', function(e) {
      var media = e.target.closest('.mpdp-hero__media');
      if (!media || media.classList.contains('mpdp-hero__media--video')) return;
      var rect = media.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      media.style.setProperty('--zoom-x', x + '%');
      media.style.setProperty('--zoom-y', y + '%');
    });

    // Mobile: tap to toggle zoom
    if (!matchMedia('(hover: hover) and (pointer: fine)').matches) {
      gallery.addEventListener('click', function(e) {
        var media = e.target.closest('.mpdp-hero__media');
        if (!media || media.classList.contains('mpdp-hero__media--video')) return;
        if (e.target.closest('[data-mpdp-thumb-index]')) return;
        media.classList.toggle('mpdp-hero__media--zoomed');
      });
    }
  }

  /* ----------------------------------------------------------
     INIT
     ---------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ----------------------------------------------------------
     BUNDLE PICKER — qty-preset cards next to the variant pill.
     When the bundle card is selected, intercept ATC clicks and
     navigate to /discount/CODE?redirect=/cart/VID:QTY so Shopify
     applies the discount code then adds the items to cart.
     ---------------------------------------------------------- */
  function initBundleCards() {
    var cards = document.querySelectorAll('[data-mpdp-bundle-card]');
    if (!cards.length) return;

    var qtyInput   = document.querySelector('[data-mpdp-qty-input]');
    var qtyCount   = document.querySelector('[data-mpdp-qty-count]');
    var qtyWrapper = document.querySelector('[data-mpdp-qty]');
    var atcBtn     = document.querySelector('[data-mpdp-atc]');
    var stickyBtn  = document.querySelector('[data-mpdp-sticky-atc-btn]');
    var variantInput = document.querySelector('[data-mpdp-variant-id]');
    var origAtcHtml  = atcBtn ? atcBtn.innerHTML : '';

    var state = { bundle: false, qty: 1, code: '' };

    function applyState(card) {
      cards.forEach(function(c) {
        c.classList.remove('mpdp-hero__bundle-card--active');
        c.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('mpdp-hero__bundle-card--active');
      card.setAttribute('aria-pressed', 'true');

      var qty = parseInt(card.dataset.mpdpBundleQty, 10) || 1;
      var code = (card.dataset.mpdpBundleDiscount || '').trim();
      var ctaTxt = card.dataset.mpdpBundleCta || '';

      state.bundle = qty > 1 && code !== '';
      state.qty = qty;
      state.code = code;

      if (qtyInput) qtyInput.value = qty;
      if (qtyCount) qtyCount.textContent = qty;
      if (qtyWrapper) qtyWrapper.style.display = state.bundle ? 'none' : '';

      if (atcBtn) {
        if (state.bundle && ctaTxt) {
          atcBtn.textContent = ctaTxt;
        } else {
          atcBtn.innerHTML = origAtcHtml;
        }
      }
    }

    cards.forEach(function(card) {
      card.addEventListener('click', function() { applyState(card); });
    });

    /* Bundle-aware click interceptor for ATC + sticky ATC.
       Capture phase so we run before any default handler — preventDefault +
       stopPropagation block the single-item ATC code path. */
    function interceptAtc(e) {
      if (!state.bundle) return;            // single mode: let default fire
      if (!variantInput || !variantInput.value) return;
      e.preventDefault();
      e.stopPropagation();
      var vid = variantInput.value;
      window.location.href = '/discount/' + encodeURIComponent(state.code) +
        '?redirect=' + encodeURIComponent('/cart/' + vid + ':' + state.qty);
    }
    if (atcBtn) atcBtn.addEventListener('click', interceptAtc, true);
    if (stickyBtn) stickyBtn.addEventListener('click', interceptAtc, true);

    /* Initialise from whichever card is marked active in markup */
    var initial = document.querySelector('[data-mpdp-bundle-card].mpdp-hero__bundle-card--active') || cards[0];
    applyState(initial);
  }

  function init() {
    var fns = [
      initVariantSelector,
      initImageGallery,
      initImageZoom,
      initQuantitySelector,
      initBundleCards,
      initFlockCalculator,
      initAnalysisTable,
      initStickyATC,
      initFaqAccordion,
      initScrollReveal,
      // initHeroFormIntercept — handled by standalone inline script in hero section
      initJumpLinks
    ];
    fns.forEach(function(fn) {
      try { fn(); } catch(e) { console.warn('[MOULEE PDP]', fn.name, e.message); }
    });
  }
})();
